export default class KenectObserver {
  container;
  observer;

  options = {
    attributes: true,
    childList: true,
    subtree: true,
  };

  constructor(containerEl) {
    this.container = containerEl;
  }

  disconnect() {
    this.observer?.disconnect();
  }

  observe(elementToObserve, callback) {
    this.observer = new MutationObserver((mutations, observer) => {
      mutations.forEach((mutation) => callback(mutation));
    });

    this.observer.observe(elementToObserve, this.options);
  }
}
